module.exports = __webpack_public_path__ + "img/roll-call.66b34328.png";